import React from 'react';
import { SectionInfoContainer, SectionInfoItem, SectionInfoValue } from './styles';

const hasValue = (v: string | null | undefined): v is string => v != null && v !== '';

interface SectionInfoProps {
  description1: string | null;
  description2: string | null;
  description3: string | null;
}

const GuestDirectorySectionInfo: React.FC<SectionInfoProps> = ({
  description1,
  description2,
  description3,
}) => {
  const items: { key: string; value: string }[] = [];
  if (hasValue(description1)) items.push({ key: 'description1', value: description1 });
  if (hasValue(description2)) items.push({ key: 'description2', value: description2 });
  if (hasValue(description3)) items.push({ key: 'description3', value: description3 });

  if (items.length === 0) return null;

  return (
    <SectionInfoContainer>
      {items.map(({ key, value }) => (
        <SectionInfoItem key={key}>
          <SectionInfoValue>{value}</SectionInfoValue>
        </SectionInfoItem>
      ))}
    </SectionInfoContainer>
  );
};

export default GuestDirectorySectionInfo;
